module.exports = __webpack_public_path__ + "img/process.8966cad7.svg";